export default {"src":"/_next/static/media/Pomodoro.07a34d03.svg","height":418,"width":418,"blurWidth":0,"blurHeight":0};